import React, { useEffect, useState } from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

interface Config {
  force: number;
  particleCount: number;
  duration: number;
  width: number;
  height?: number;
}

const useConfettiExplosion = (enableExplosion: boolean, config: Config): JSX.Element | null => {
  const [isExploding, setIsExploding] = useState(false);

  const clearExplosion = () => setIsExploding(false);

  useEffect(() => {
    if (enableExplosion) {
      setIsExploding(true);
    }
  }, [enableExplosion]);

  if (!isExploding) return null;

  return <ConfettiExplosion {...config} onComplete={clearExplosion} />;
};

export default useConfettiExplosion;
